import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const RefulfillmentPushLocationResult_ = z.object({
  sourceLocationId: z.string(),
  name: z.string(),
  completed: z.boolean(),
  pushedCount: z.number(),
  failedCount: z.number(),
  skippedCount: z.number(),
  stopReason: z.string().nullable(),
  error: z.string().nullable(),
});
export const RefulfillmentPushLocationResult: z.ZodType<RefulfillmentPushLocationResult> =
  RefulfillmentPushLocationResult_;
export interface RefulfillmentPushLocationResult extends z.infer<
  typeof RefulfillmentPushLocationResult_
> {}

const RefulfillmentPushStatus_ = z.object({
  status: z.enum(["running", "completed", "partial", "failed", "not_found"]),
  locations: z.array(RefulfillmentPushLocationResult_),
  error: z.string().nullable(),
});
export const RefulfillmentPushStatus: z.ZodType<RefulfillmentPushStatus> =
  RefulfillmentPushStatus_;
export interface RefulfillmentPushStatus extends z.infer<
  typeof RefulfillmentPushStatus_
> {}

/** Reads a push run's Temporal status; results only once it has finished. */
export const getRefulfillmentInventoryPushStatus = unaryRpc({
  name: "getRefulfillmentInventoryPushStatus" as const,
  input: z.object({ merchantTeamId: zExt.objectId(), workflowId: z.string() }),
  output: RefulfillmentPushStatus_,
});
